import {
  StepType,
  WizardStep,
} from 'src/app/components/wizard/wizard.component';

export enum InvestorSectionType {
  statement,
  knowledgeTest,
}

const investmentQualificationWizardSteps: WizardStep<InvestorSectionType>[] = [
  {
    icon: '1',
    title: 'general.statement',
    isActive: true,
    stepType: StepType.available,
    sectionType: InvestorSectionType.statement,
  },
  {
    icon: '2',
    title:
      'registrationWizard.investmentQualificationTest.knowledgeTestForm.knowledgeTest',
    isActive: false,
    stepType: StepType.available,
    sectionType: InvestorSectionType.knowledgeTest,
  },
];

export function getInvestmentQualificationWizardSteps(): WizardStep<InvestorSectionType>[] {
  return investmentQualificationWizardSteps;
}
